import script from "./checkinCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkinCard.vue?vue&type=script&setup=true&lang=ts"

import "./checkinCard.vue?vue&type=style&index=0&id=48d9715e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d9715e"]])

export default __exports__